import Sidebar from "components/Sidebar";
import UserReview from "components/UserReview.tsx";
import Dashboard from "pages/Dashboard";
import Evaluation from "pages/Evaluation";
import Feedback from "pages/Feedback";
import Goals from "pages/Goals";
import Reviews from "pages/Reviews";
import Team from "pages/Team";
import { Route, Routes } from "react-router-dom";

const App = () => {
  return (
    <>
      <Sidebar>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/goals" element={<Goals />} />
          <Route path="/evaluation" element={<UserReview />} />
          <Route path="/evaluation/:id" element={<Evaluation />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/team" element={<Team/>} />
        </Routes>
      </Sidebar>
    </>
  );
};

export default App;
